import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import ErrorBoundary from './components/errorHandling/ErrorBoundary';
import { MigratorDashboard } from './pages/Dashboard/MigratorDashboard';
import CaptureSnapshot from './pages/Snapshot/SnapshotSetup';
import MigrationSetup from './pages/Migrations/MigrationSetup';
import LoginPage from './pages/Login/LoginPage';
import ApproveTransformationsPage from './pages/Migrations/ApproveTransformationsPage';
import ApproveExportPage from './pages/Migrations/ApproveExportPage';
import { MigrationLogsPage } from './pages/Migrations/MigrationLogsPage';
import SnapshotComparisonToolPage from './pages/SnapshotComparisonTool/SnapshotComparisonToolPage';
import RollbackPreviewPage from './pages/Rollback/RollbackPreviewPage';
import RollbackInitiationPage from './pages/Rollback/RollbackInitiationPage';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast/ToastProvider';
import ProtectedRoute from './components/ProtectedRoute';

export const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route
                path="/landing"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <MigratorDashboard />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <MigratorDashboard />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/CaptureSnapshot"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="capture-snapshot">
                      <CaptureSnapshot />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/MigrationSetup"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="migration-setup">
                      <MigrationSetup />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ApproveTransformationsPage"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="approve-transformations">
                      <ApproveTransformationsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ApproveExportPage"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="approve-export">
                      <ApproveExportPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/MigrationLogs"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="migration-logs">
                      <MigrationLogsPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/SnapshotComparisonTool"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="snapshot-comparison">
                      <SnapshotComparisonToolPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/RollbackInitiation"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="rollback-initiation">
                      <RollbackInitiationPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/RollbackPreview"
                element={
                  <ProtectedRoute>
                    <AppLayout variant="rollback-preview">
                      <RollbackPreviewPage />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};
